<template>
  <p>
    El medidor de ozono troposférico, utiliza un principio de medición basado en
    la absorción de radiación ultravioleta para determinar la concentración del
    ozono presente en el aire.
  </p>
  <p>
    El ozono es un gas oxidante que, en niveles elevados, es perjudicial para la
    salud humana y el medio ambiente por lo que es un parámetro de referencia
    del Estándar de Calidad Ambiental (ECA) para aire a nivel nacional e
    internacional. Tiene un rango de medición de 0.4 a 1,000 ppb de ozono y un
    flujo de 2 LPM.
  </p>
  <p>
    Este instrumento cumple con las exigencias del programa de Vigilancia
    Atmosférica Global de la Organización Mundial de Meteorología (VAG/OMM).
  </p>
  <img
    class="thumbnail instrument"
    src="@/assets/images/microfisica/instrumentos/ozono.webp"
    alt="Medidor de ozono"
  />
  <p>
    <b>
      Variables más importantes que registra:
    </b>
  </p>
  <List marked>
    <li>Concentración de ozono (ppb)</li>
  </List>

  <p>
    <b>Marca y modelo: </b> <br />
    Thermo Scientific, 49i
  </p>
  <p>
    <b>País: </b> <br />
    EE.UU.
  </p>
  <p>
    <b>Especificaciones técnicas: </b> <br />
    <a
      href="https://www.thermofisher.com/order/catalog/product/49I"
      target="_blank"
      >https://www.thermofisher.com/order/catalog/product/49I</a
    >
  </p>
  <p>
    <b>Responsable: </b> <br />
    lsuarez@igp.gob.pe
  </p>
</template>

<script>
import List from "@/components/ui/objects/List";
export default {
  // Obtener el nombre de la ruta

  name: "FotometroSolar",
  setup() {
    const basePath = process.env.VUE_APP_PUBLIC_PATH;
    return {
      basePath,
    };
  },
  components: { List },
};
</script>
